module.exports = __webpack_public_path__ + "img/W-S05.e2349b37.jpg";